import { ConnectivityToStaycation } from '../../_components/ConnectivityToStaycation/ConnectivityToStaycation';
import styles from '../StepIntro.module.scss';

import { OptionCard } from './OptionCard';

type BookingComOptionProps = {
  onClick: () => void;
  hasRoom: boolean;
};

export const BookingComOption = ({
  onClick,
  hasRoom,
}: BookingComOptionProps) => (
  <OptionCard
    category="OPTION 2"
    title="Activate Auto Inventory"
    subtitle={
      <p>
        Your channel manager isn't listed?
        <br /> Simplify your room inventory management by syncing with
        Booking.com.
      </p>
    }
    buttonLabel="Set up Auto Inventory"
    buttonProps={{ type: 'primary' }}
    onButtonClick={onClick}
    disabled={!hasRoom}
  >
    <div className={styles.children}>
      <ConnectivityToStaycation />
    </div>
  </OptionCard>
);
